import 'styles/VerificationPanel.scss';
import errorMark from 'assets/images/error.png';
import redeemedMark from 'assets/images/redeemed.png';
import VerificationForm from 'Components/VerificationForm';
import VerificationLoader from 'Components/VerificationLoader';
import React, { useEffect, useState } from 'react';
import { VERIFY_PROMO } from 'urls';
import Redeem from './Redeem';
import Unverified from './Unverified';

const VerificationPanel = () => {
    const [status, setStatus] = useState("INIT");
    const [voucherCode, setVoucherCode] = useState(null);
    const [voucherSource, setVoucherSource] = useState(null);
    const [error, setError] = useState(null);
    

    async function verifyPromo() {
        setError(null);
        const inputField = document.querySelector('.text-field input');
        if (inputField && inputField.value.length === 14) {
            if (inputField.value) {
                setVoucherCode(inputField.value)
                setStatus("LOADING")
                try {
                    let promoCode = voucherCode.replace(/-/g, '');
                    const response = await fetch(VERIFY_PROMO, {
                        method: 'POST',
                        body: JSON.stringify({
                            "search_term": promoCode
                        })
                    })
                    if (response.ok) {
                        const data = await response.json();
                        if (data.voucher_details.length === 0) {
                            setStatus("INVALID")
                            setError(null)
                        } 
                        else {
                            if(data.voucher_details[0].approval_status.value !== "APPROVAL_STATUS_PENDING") {
                                setStatus("REDEEMED")
                                setError(null)
                            } else {
                                setVoucherSource(data.voucher_details[0].description);
                                setStatus("VERIFIED")
                                setError(null)
                            }
                        }   
                    }
                } catch (e) {
                    setError("Something went wrong! Please try again later.")
                    setStatus("INIT")
                }
            }
        } else {
            setError('Please enter a valid voucher code');
            return;
        }
    }
    switch (status) {
        case "LOADING":
            return <VerificationLoader />
        case "INIT":
            return <VerificationForm
                        verifyPromo={verifyPromo}
                        error={error}
                        setVoucherCode={setVoucherCode}
                        setStatus={setStatus}
                    />
        case "VERIFIED":
            return <Redeem
                voucherCode={voucherCode}
                voucherSource={voucherSource}
                setStatus={setStatus}
            />
        case "INVALID":
            return <Unverified
                statusImage={errorMark}
                statusText="Failed to verify the voucher code"
                messageText="This voucher code cannot be verified. Kindly check the code and enter it again."
                voucherCode={voucherCode}
                setStatus={setStatus}
            />
        case "REDEEMED":
            return <Unverified
                        statusImage={redeemedMark}
                        statusText="This voucher has already been redeemed"
                        messageText="Kindly ask the customer for a valid voucher code."
                        voucherCode={voucherCode}
                        setStatus={setStatus}
                    />
        default:
            return <></>
    }
}

export default VerificationPanel;